import { useMemo } from 'react';
import { NextPage } from 'next';

import { PageSection } from 'types/pages';

import PageContainer from 'components/layout/PageContainer';
import SectionsWrapper from 'components/layout/SectionsWrapper';
import WrapperPublic from 'components/wrappers/Public/component';

import SectionContent from './sections/Content';
import SectionNewsletter from './sections/Newsletter';
import StyledComponent from './styles';
import { Props } from './types';

const PageContact: NextPage<Props> = ({ pageTranslations }) => {
    const sections: PageSection[] = useMemo(() => [
        {
            slug: 'content',
            order: 1,
            isVisible: true,
            children: (slug, translations) => (
                <SectionContent
                    key={slug}
                    translations={translations}
                />
            ),
        }, {
            slug: 'newsletter',
            order: 2,
            isVisible: true,
            children: (slug, translations) => (
                <SectionNewsletter
                    key={slug}
                    translations={translations}
                />
            ),
        }], []);

    return (
        <WrapperPublic navigationVisibility={{ footer: true, navigation: true }}>
            <StyledComponent className='page-contact'>
                <PageContainer>
                    <SectionsWrapper
                        sections={sections}
                        localTranslations={pageTranslations?.sections}
                    />
                </PageContainer>
            </StyledComponent>
        </WrapperPublic>
    );
};

export default PageContact;
